import { useState } from "react";
import { axiosInterceptor } from "../services/authInterceptor";
import environment from "../../../environments/environment";
import * as constants from "../../../constants";
import { useDispatch } from "react-redux";
import { notifyUser } from "../Utils/notifyUser";
import { useTranslation } from "react-i18next";

export const usePreviousMonths = (clientId: any, numOfMonths: any) => {
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const [montlyEndDateList, setMontlyEndDateList] = useState([]);
  const [monthEndDate, setMonthEndDate] = useState<string | null>("");
  const GET_MONTHS = environment.getListOfPreviousMonthsURL;
  const fetchPreviousMonths = async () => {
    try {
      const response = await axiosInterceptor.get(
        `${GET_MONTHS}${numOfMonths}?clientId=${clientId}`
      );

      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        const formattedList = response?.data?.data?.map((dateStr: string) => {
          const date = new Date(dateStr);
          const formatted = date.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          });
          return {
            value: dateStr,
            label: formatted,
          };
        });

        setMontlyEndDateList(formattedList);
        //aduitLog
        //  dispatch(setCreateAuditLog({ month: response?.data?.data[0] }))

        setMonthEndDate(response?.data?.data[0]);
      }
    } catch (error: any) {
      notifyUser(
        error.response?.data?.message ?? translate("apiRequestFailed"),
        "error",
        translate("months")
      );
    }
  };

  return {
    montlyEndDateList,
    monthEndDate,
    fetchPreviousMonths,
    setMonthEndDate,
  };
};
